var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ]
    },
    [
      _c(
        "div",
        {
          staticClass: "c_page-title",
          staticStyle: { "margin-bottom": "20px" }
        },
        [
          _c("div", [_vm._v("包裹点货详情")]),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "icon-fresh",
              attrs: { size: "mini", icon: "el-icon-refresh" },
              on: {
                click: function($event) {
                  return _vm.fetchData(true)
                }
              }
            },
            [_vm._v("刷新")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "blockinfo" },
        [
          _vm.resData
            ? _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "el-row",
                        [
                          _c("el-col", { attrs: { span: 24 } }, [
                            _c("div", { staticClass: "info-row" }, [
                              _c("span", [_vm._v("包裹号:")]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(_vm.resData.package_no))
                              ])
                            ])
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        [
                          _c("el-col", { attrs: { span: 24 } }, [
                            _c("div", { staticClass: "info-row" }, [
                              _c("span", [_vm._v("包裹商品数量：")]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(_vm.resData.goods_num))
                              ])
                            ])
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "el-row",
                        [
                          _c("el-col", { attrs: { span: 24 } }, [
                            _c("div", { staticClass: "info-row" }, [
                              _c("span", [_vm._v("商家：")]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(_vm.resData.supply_name))
                              ])
                            ])
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        [
                          _c("el-col", { attrs: { span: 24 } }, [
                            _c("div", { staticClass: "info-row" }, [
                              _c("span", [_vm._v("市场：")]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(_vm.resData.market_name))
                              ])
                            ])
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "el-row",
                        [
                          _c("el-col", { attrs: { span: 24 } }, [
                            _c("div", { staticClass: "info-row" }, [
                              _c("span", [_vm._v("代采组：")]),
                              _vm._v(" "),
                              _c("span", [_vm._v(_vm._s(_vm.resData.pgname))])
                            ])
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        [
                          _c("el-col", { attrs: { span: 24 } }, [
                            _c("div", { staticClass: "info-row" }, [
                              _c("span", [_vm._v("代采员：")]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(_vm.resData.pm_member_name))
                              ])
                            ])
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "el-row",
                        [
                          _c("el-col", { attrs: { span: 24 } }, [
                            _c("div", { staticClass: "info-row" }, [
                              _c("span", [_vm._v("已提交批次单：")]),
                              _vm._v(" "),
                              _c("span", [_vm._v(_vm._s(_vm.resData.pici_num))])
                            ])
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        [
                          _c("el-col", { attrs: { span: 24 } }, [
                            _c("div", { staticClass: "info-row" }, [
                              _c("span", [_vm._v("收包图片：")]),
                              _vm._v(" "),
                              _c("span", [
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      { name: "viewer", rawName: "v-viewer" }
                                    ],
                                    staticStyle: {
                                      width: "40px",
                                      height: "40px",
                                      overflow: "hidden",
                                      cursor: "pointer",
                                      display: "inline-block",
                                      "vertical-align": "text-top"
                                    }
                                  },
                                  _vm._l(_vm.resData.package_img, function(
                                    item,
                                    index
                                  ) {
                                    return _c("img", {
                                      key: index,
                                      staticStyle: {
                                        width: "100%",
                                        height: "100%",
                                        "vertical-align": "middle"
                                      },
                                      attrs: { src: item }
                                    })
                                  }),
                                  0
                                )
                              ])
                            ])
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "el-row",
                        [
                          _c("el-col", { attrs: { span: 24 } }, [
                            _c("div", { staticClass: "info-row" }, [
                              _c("span", [_vm._v("异常处理人：")]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(_vm.resData.yc_admin_name))
                              ])
                            ])
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        [
                          _c("el-col", { attrs: { span: 24 } }, [
                            _c("div", { staticClass: "info-row" }, [
                              _c("span", [_vm._v("异常处理时间：")]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(_vm.resData.create_time))
                              ])
                            ])
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "el-row",
                        [
                          _c("el-col", { attrs: { span: 24 } }, [
                            _c("div", { staticClass: "info-row" }, [
                              _c("span", [_vm._v("包裹点货状态：")]),
                              _vm._v(" "),
                              _vm.resData.package_dabiao_status == 3
                                ? _c(
                                    "span",
                                    { staticStyle: { color: "blue" } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.resData.package_dabiao_status_txt
                                        )
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.resData.package_dabiao_status == 2
                                ? _c(
                                    "span",
                                    { staticStyle: { color: "red" } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.resData.package_dabiao_status_txt
                                        )
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.resData.package_dabiao_status == 1
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.resData.package_dabiao_status_txt
                                      )
                                    )
                                  ])
                                : _vm._e()
                            ])
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-row",
                        [
                          _c("el-col", { attrs: { span: 24 } }, [
                            _c("div", { staticClass: "info-row" }, [
                              _c("span", [_vm._v("异常原因：")]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(_vm.resData.yc_remark))
                              ])
                            ])
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    {
                      staticStyle: { "margin-bottom": "20px" },
                      attrs: { span: 24 }
                    },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 4 } },
                        [
                          _c("el-row", [
                            _c("div", { staticClass: "info-row" }, [
                              _c("span", [_vm._v(" 包裹状态：")]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(_vm.resData.packge_status_text))
                              ])
                            ])
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 4 } },
                        [
                          _c("el-row", [
                            _c("div", { staticClass: "info-row" }, [
                              _c("span", [_vm._v(" 打标来源：")]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(_vm.resData.db_source_text))
                              ])
                            ])
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 4 } },
                        [
                          _c("el-row", [
                            _c("div", { staticClass: "info-row" }, [
                              _c("span", [_vm._v(" 爆版发货单：")]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(_vm.resData.invoice_no_text))
                              ])
                            ])
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 4 } },
                        [
                          _c("el-row", [
                            _c("div", { staticClass: "info-row" }, [
                              _c("span", [_vm._v(" 快递运单号：")]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(_vm.resData.shipping_num))
                              ])
                            ])
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    {
                      staticStyle: { "margin-bottom": "20px" },
                      attrs: { span: 24 }
                    },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 4 } },
                        [
                          _c("el-row", [
                            _c("div", { staticClass: "info-row" }, [
                              _c("span", [_vm._v(" 作废原因：")]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(_vm.resData.waste_reason_text))
                              ])
                            ])
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 4 } },
                        [
                          _c("el-row", [
                            _c(
                              "div",
                              {
                                staticClass: "info-row",
                                staticStyle: { display: "table" }
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "table-cell",
                                      width: "78px"
                                    }
                                  },
                                  [_vm._v("关联包裹：")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "table-cell",
                                      "word-break": "break-all"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.resData.relation_packages) +
                                        "\n              "
                                    )
                                  ]
                                )
                              ]
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { "margin-bottom": "20px" } },
        [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: { data: _vm.resData.pici_data, border: "" }
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "goods_num",
                  label: "包裹商品数",
                  align: "center"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "pici_eff_num",
                  label: "有效点货",
                  align: "center"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "pici_inv_num",
                  label: "不良品",
                  align: "center"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "pici_no_data_num",
                  label: "无数据商品",
                  align: "center"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "diff_num", label: "差异", align: "center" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "note",
                  label: "操作",
                  align: "center",
                  width: "300px"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm.resData.package_dabiao_status == "2"
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "success" },
                                on: {
                                  click: function($event) {
                                    _vm.dialogFormVisible = true
                                  }
                                }
                              },
                              [_vm._v("处理")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  ["1", "2"].includes(
                                    _vm.resData.packge_status
                                  ) && !["3"].includes(_vm.resData.db_source),
                                expression:
                                  "\n              ['1', '2'].includes(resData.packge_status) &&\n              !['3'].includes(resData.db_source)\n            "
                              }
                            ],
                            attrs: { type: "danger" },
                            on: { click: _vm.showWasteDialog }
                          },
                          [_vm._v("作废")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: ["3", "4"].includes(
                                  _vm.resData.packge_status
                                ),
                                expression:
                                  "['3', '4'].includes(resData.packge_status)"
                              }
                            ],
                            attrs: { type: "infor" },
                            on: { click: _vm.showRelationDialog }
                          },
                          [_vm._v("关联包裹")]
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { staticClass: "filter" },
        [
          _c("el-col", [
            _c(
              "div",
              {
                staticStyle: {
                  background: "#f3f3f3",
                  height: "50px",
                  "line-height": "50px",
                  padding: "0 25px",
                  display: "flex",
                  "align-items": "center"
                }
              },
              [
                _c("div", [_vm._v("包裹批次点货数据")]),
                _vm._v(" "),
                _c(
                  "el-select",
                  {
                    staticStyle: { "margin-left": "auto" },
                    attrs: { multiple: "", placeholder: "请选择批次号" },
                    on: { change: _vm.getPiciGoods },
                    model: {
                      value: _vm.pici_arr,
                      callback: function($$v) {
                        _vm.pici_arr = $$v
                      },
                      expression: "pici_arr"
                    }
                  },
                  _vm._l(_vm.resData.pici_arr_kv, function(item) {
                    return _c("el-option", {
                      key: item.value,
                      attrs: { label: item.label, value: item.value }
                    })
                  }),
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "sub_table",
                staticStyle: { "padding-top": "20px" }
              },
              [
                _c(
                  "div",
                  { staticClass: "card-title" },
                  [
                    _c("div", [
                      _vm._v("有效商品（" + _vm._s(_vm.effGoods.total) + "）")
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-form",
                      {
                        staticClass: "demo-form-inline",
                        attrs: {
                          inline: true,
                          model: _vm.filteredEffGoods,
                          size: "mini"
                        }
                      },
                      [
                        _c(
                          "el-form-item",
                          [
                            _c("el-input", {
                              attrs: { placeholder: "商品名称" },
                              model: {
                                value: _vm.filteredEffGoods.goods_name,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.filteredEffGoods,
                                    "goods_name",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "filteredEffGoods.goods_name"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          [
                            _c("el-input", {
                              attrs: { placeholder: "商品货号" },
                              model: {
                                value: _vm.filteredEffGoods.goods_no,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.filteredEffGoods,
                                    "goods_no",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "filteredEffGoods.goods_no"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          [
                            _c("el-input", {
                              attrs: { placeholder: "sku" },
                              model: {
                                value: _vm.filteredEffGoods.sku,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.filteredEffGoods,
                                    "sku",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "filteredEffGoods.sku"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "primary" },
                                on: { click: _vm.getEffGoods }
                              },
                              [_vm._v("查询")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-table",
                  {
                    staticStyle: { width: "100%" },
                    attrs: {
                      data: _vm.effGoods.data,
                      border: "",
                      height: "400"
                    }
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        prop: "dbrid",
                        label: "打标编号",
                        align: "center"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "pgname",
                        label: "代采组",
                        align: "center"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "goods_img",
                        label: "商品图片",
                        align: "center"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "div",
                                {
                                  directives: [
                                    { name: "viewer", rawName: "v-viewer" }
                                  ],
                                  staticStyle: {
                                    width: "40px",
                                    height: "40px",
                                    overflow: "hidden",
                                    cursor: "pointer",
                                    display: "inline-block"
                                  }
                                },
                                _vm._l(scope.row.goods_img, function(
                                  item,
                                  index
                                ) {
                                  return _c("img", {
                                    key: index,
                                    staticStyle: {
                                      width: "100%",
                                      height: "100%"
                                    },
                                    attrs: { src: item }
                                  })
                                }),
                                0
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "goods_name",
                        label: "商品名称",
                        align: "center"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "goods_no",
                        label: "商品货号",
                        align: "center"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { prop: "co_val", label: "颜色", align: "center" }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { prop: "si_val", label: "尺码", align: "center" }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { prop: "sku", label: "sku", align: "center" }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "market_price",
                        label: "代采价",
                        align: "center"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { prop: "dbid", label: "打标ID", align: "center" }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "type_text",
                        label: "类型",
                        align: "center"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "admin_name",
                        label: "打标人",
                        align: "center"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "create_time",
                        label: "打标时间",
                        align: "center"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "pici_no",
                        label: "批次号",
                        align: "center"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "pici_type",
                        label: "批次类型",
                        align: "center"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "pici_create_name",
                        label: "批次创建人",
                        align: "center"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "pici_create_time",
                        label: "批次创建时间",
                        align: "center"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "commit_time",
                        label: "提交时间",
                        align: "center"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticStyle: { "text-align": "right", padding: "25px" } },
                  [
                    _c("el-pagination", {
                      attrs: {
                        "current-page": _vm.effGoods.current_page,
                        background: "",
                        layout: "total, prev, pager, next, jumper ",
                        total: _vm.effGoods.total,
                        "page-size": 10
                      },
                      on: {
                        "update:currentPage": function($event) {
                          return _vm.$set(_vm.effGoods, "current_page", $event)
                        },
                        "update:current-page": function($event) {
                          return _vm.$set(_vm.effGoods, "current_page", $event)
                        },
                        "current-change": _vm.getEffGoods
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "sub_table" },
              [
                _c(
                  "div",
                  { staticClass: "card-title" },
                  [
                    _c("div", [
                      _vm._v(
                        "不良品商品（" + _vm._s(_vm.invalidGoods.total) + "）"
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-form",
                      {
                        staticClass: "demo-form-inline",
                        attrs: {
                          inline: true,
                          model: _vm.filteredInvalidGoods,
                          size: "mini"
                        }
                      },
                      [
                        _c(
                          "el-form-item",
                          [
                            _c("el-input", {
                              attrs: { placeholder: "商品名称" },
                              model: {
                                value: _vm.filteredInvalidGoods.goods_name,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.filteredInvalidGoods,
                                    "goods_name",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "filteredInvalidGoods.goods_name"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          [
                            _c("el-input", {
                              attrs: { placeholder: "商品货号" },
                              model: {
                                value: _vm.filteredInvalidGoods.goods_no,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.filteredInvalidGoods,
                                    "goods_no",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "filteredInvalidGoods.goods_no"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          [
                            _c("el-input", {
                              attrs: { placeholder: "sku" },
                              model: {
                                value: _vm.filteredInvalidGoods.sku,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.filteredInvalidGoods,
                                    "sku",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "filteredInvalidGoods.sku"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          [
                            _c(
                              "el-button",
                              {
                                attrs: { type: "primary" },
                                on: { click: _vm.getInvalidGoods }
                              },
                              [_vm._v("查询")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-table",
                  {
                    staticStyle: { width: "100%" },
                    attrs: {
                      data: _vm.invalidGoods.data,
                      border: "",
                      height: "400"
                    }
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        prop: "dbrid",
                        label: "打标编号",
                        align: "center"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "pgname",
                        label: "代采组",
                        align: "center"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "goods_img",
                        label: "商品图片",
                        align: "center"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "div",
                                {
                                  directives: [
                                    { name: "viewer", rawName: "v-viewer" }
                                  ],
                                  staticStyle: {
                                    width: "40px",
                                    height: "40px",
                                    overflow: "hidden",
                                    cursor: "pointer",
                                    display: "inline-block"
                                  }
                                },
                                _vm._l(scope.row.goods_img, function(
                                  item,
                                  index
                                ) {
                                  return _c("img", {
                                    key: index,
                                    staticStyle: {
                                      width: "100%",
                                      height: "100%"
                                    },
                                    attrs: { src: item }
                                  })
                                }),
                                0
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "goods_name",
                        label: "商品名称",
                        align: "center"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "goods_no",
                        label: "商品货号",
                        align: "center"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { prop: "co_val", label: "颜色", align: "center" }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { prop: "si_val", label: "尺码", align: "center" }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { prop: "sku", label: "sku", align: "center" }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "market_price",
                        label: "代采价",
                        align: "center"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { prop: "dbid", label: "打标ID", align: "center" }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "type_text",
                        label: "类型",
                        align: "center"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "admin_name",
                        label: "打标人",
                        align: "center"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "create_time",
                        label: "打标时间",
                        align: "center"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "pici_no",
                        label: "批次号",
                        align: "center"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "pici_type",
                        label: "批次类型",
                        align: "center"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "pici_create_name",
                        label: "批次创建人",
                        align: "center"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "pici_create_time",
                        label: "批次创建时间",
                        align: "center"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "commit_time",
                        label: "提交时间",
                        align: "center"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticStyle: { "text-align": "right", padding: "25px" } },
                  [
                    _c("el-pagination", {
                      attrs: {
                        "current-page": _vm.invalidGoods.current_page,
                        background: "",
                        layout: "total, prev, pager, next, jumper ",
                        total: _vm.invalidGoods.total,
                        "page-size": 10
                      },
                      on: {
                        "update:currentPage": function($event) {
                          return _vm.$set(
                            _vm.invalidGoods,
                            "current_page",
                            $event
                          )
                        },
                        "update:current-page": function($event) {
                          return _vm.$set(
                            _vm.invalidGoods,
                            "current_page",
                            $event
                          )
                        },
                        "current-change": _vm.getInvalidGoods
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "sub_table" },
              [
                _c("div", { staticClass: "card-title" }, [
                  _c("div", [
                    _vm._v(
                      "无数据商品（" + _vm._s(_vm.noDataGoods.total) + "）"
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "el-table",
                  {
                    staticStyle: { width: "100%" },
                    attrs: {
                      data: _vm.noDataGoods.data,
                      border: "",
                      height: "400"
                    }
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        prop: "ndgid",
                        label: "无数据标id",
                        align: "center"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "img",
                        label: "商品图片",
                        align: "center"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "div",
                                {
                                  directives: [
                                    { name: "viewer", rawName: "v-viewer" }
                                  ],
                                  staticStyle: {
                                    width: "40px",
                                    height: "40px",
                                    overflow: "hidden",
                                    cursor: "pointer",
                                    display: "inline-block"
                                  }
                                },
                                _vm._l(scope.row.img, function(item, index) {
                                  return _c("img", {
                                    key: index,
                                    staticStyle: {
                                      width: "100%",
                                      height: "100%"
                                    },
                                    attrs: { src: item }
                                  })
                                }),
                                0
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { prop: "co_val", label: "颜色", align: "center" }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { prop: "si_val", label: "尺码", align: "center" }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "pgname",
                        label: "代采组",
                        align: "center"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { prop: "dbid", label: "打标id", align: "center" }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "admin_name",
                        label: "创建人",
                        align: "center"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { prop: "note", label: "备注", align: "center" }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "create_time",
                        label: "创建时间",
                        align: "center"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "pici_no",
                        label: "批次号",
                        align: "center"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "pici_type",
                        label: "批次类型",
                        align: "center"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "pici_create_name",
                        label: "批次创建人",
                        align: "center"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "pici_create_time",
                        label: "批次创建时间",
                        align: "center"
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "commit_time",
                        label: "提交时间",
                        align: "center"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticStyle: { "text-align": "right", padding: "25px" } },
                  [
                    _c("el-pagination", {
                      attrs: {
                        "current-page": _vm.noDataGoods.current_page,
                        background: "",
                        layout: "total, prev, pager, next, jumper ",
                        total: _vm.noDataGoods.total,
                        "page-size": 10
                      },
                      on: {
                        "update:currentPage": function($event) {
                          return _vm.$set(
                            _vm.noDataGoods,
                            "current_page",
                            $event
                          )
                        },
                        "update:current-page": function($event) {
                          return _vm.$set(
                            _vm.noDataGoods,
                            "current_page",
                            $event
                          )
                        },
                        "current-change": _vm.getNoDataGoods
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "处理异常",
            visible: _vm.dialogFormVisible,
            "close-on-click-modal": false,
            center: "",
            width: "30%"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogFormVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            { attrs: { model: _vm.yc_form } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "异常类型:" } },
                [
                  [
                    _c(
                      "el-radio",
                      {
                        attrs: { label: "1" },
                        model: {
                          value: _vm.yc_form.yc_type,
                          callback: function($$v) {
                            _vm.$set(_vm.yc_form, "yc_type", $$v)
                          },
                          expression: "yc_form.yc_type"
                        }
                      },
                      [_vm._v("商家报错包裹数量")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-radio",
                      {
                        attrs: { label: "2" },
                        model: {
                          value: _vm.yc_form.yc_type,
                          callback: function($$v) {
                            _vm.$set(_vm.yc_form, "yc_type", $$v)
                          },
                          expression: "yc_form.yc_type"
                        }
                      },
                      [_vm._v("收包人员录错包裹数量")]
                    )
                  ]
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "异常原因备注:" } },
                [
                  _c("el-input", {
                    attrs: { autocomplete: "off" },
                    model: {
                      value: _vm.yc_form.yc_remark,
                      callback: function($$v) {
                        _vm.$set(_vm.yc_form, "yc_remark", $$v)
                      },
                      expression: "yc_form.yc_remark"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.dialogFormVisible = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.update } },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "作废原因",
            visible: _vm.dialog_setting.waste.show,
            "close-on-click-modal": false,
            center: "",
            width: "20%"
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.dialog_setting.waste, "show", $event)
            }
          }
        },
        [
          _vm._l(_vm.resData.waste_reason_map, function(item, key) {
            return _c(
              "div",
              { key: key, staticStyle: { "margin-bottom": "20px" } },
              [
                _c(
                  "el-radio",
                  {
                    attrs: { label: key },
                    model: {
                      value: _vm.dialog_setting.waste.waste_reason,
                      callback: function($$v) {
                        _vm.$set(_vm.dialog_setting.waste, "waste_reason", $$v)
                      },
                      expression: "dialog_setting.waste.waste_reason"
                    }
                  },
                  [_vm._v(_vm._s(item))]
                )
              ],
              1
            )
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticStyle: { "text-align": "right" },
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.dialog_setting.waste.show = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.confirmWaste } },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "包裹关联",
            visible: _vm.dialog_setting.relation.show,
            "close-on-click-modal": false,
            center: "",
            width: "30%"
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.dialog_setting.relation, "show", $event)
            }
          }
        },
        [
          _c("el-input", {
            ref: "relationPackageNosRef",
            attrs: {
              type: "textarea",
              placeholder: "请输入需关联的包裹号, 如有多个请用换行隔开",
              autosize: { minRows: 4, maxRows: 10 }
            },
            model: {
              value: _vm.dialog_setting.relation.package_nos,
              callback: function($$v) {
                _vm.$set(_vm.dialog_setting.relation, "package_nos", $$v)
              },
              expression: "dialog_setting.relation.package_nos"
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticStyle: { "text-align": "right" },
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.dialog_setting.relation.show = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.confirmRelation }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-title" }, [
      _c("div", [_vm._v("包裹点货汇总")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-284ce9fb", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-284ce9fb","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/supply/PackageDetail.vue
// module id = null
// module chunks = 